export default __webpack_public_path__ + "static/media/icon-kneel.92a51a94.svg";